export var lineChartData = [
    {
        "name": "Karthikeyan",
        "series": [
          {
            "name": "2016",
            "value": "15000"
          },
          {
            "name": "2017",
            "value": "20000"
          },
          {
            "name": "2018",
            "value": "25000"
          },
          {
            "name": "2019",
            "value": "30000"
          }
        ],
      },
      {
        "name": "Gnana Prakasam",
        "series": [
          {
            "name": "2016",
            "value": "4000"
          },
          {
            "name": "2017",
            "value": "4500"
          },
          {
            "name": "2018",
            "value": "10000"
          },
          {
            "name": "2019",
            "value": "15000"
          }
        ],
      },
      {
        "name": "Kumaresan",
        "series": [
          {
            "name": "2016",
            "value": "5000"
          },
          {
            "name": "2017",
            "value": "8000"
          },
          {
            "name": "2018",
            "value": "15000"
          },
          {
            "name": "2019",
            "value": "35000"
          }
        ],
      }
  ];